import React from 'react';
import styled from 'styled-components';
import { contentDelimiterStyles, appFooterHeight } from 'components/layout';
import ikeaSkapaToken from '@ingka/variables';

const FooterContainer = styled.footer`
  background-color: ${ikeaSkapaToken.colourIconLight};
  font-size: 16px;
  color: white;
  text-align: center;
  height: 60px;
`;

const FooterContent = styled.div`
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${contentDelimiterStyles};
  height: ${appFooterHeight};
  padding: 15px 16px;
  margin: 0;
`;

const CopyRight = styled.p`
  font-size: 16px;
  margin-left: 0;
`;
const AppFooter = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <CopyRight>© Inter IKEA Systems B.V. 1999 - {new Date().getFullYear()}</CopyRight>
      </FooterContent>
    </FooterContainer>
  );
};

export default AppFooter;
